module.exports = __webpack_public_path__ + "static/media/ico-email-hover.5064f1f7.svg";